import React, {FC} from 'react';

/** 隐私政策中文正文（i18n：壳组件按语言选择 zh/en 内容组件，类名复用 PrivacyPolicy__* BEM） */
const ZhContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">生效时间: 2026年8月28日</p>
      <p className="v3-doc-meta">上次更新时间: 2026年8月28日</p>
      <h3>隐私保护说明</h3>
      <p>欢迎您使用象寄提供的产品及服务！</p>
      <p>
        象寄（以下简称“象寄”“我们”）非常重视您的个人信息和隐私保护。本《隐私政策》（以下简称“本政策”）旨在向您说明，当您注册、登录、访问或使用象寄的网站、网页应用、客户端、浏览器插件、API及其他相关服务时，
        我们如何收集、使用、存储、共享、保护和处理您的个人信息，以及您依法享有的相关权利。
      </p>
      <p>
        象寄主要为跨境电商及其他商业用户提供AI视觉内容处理与创作服务，包括但不限于图片翻译、图片编辑、图片生成、商品场景图生成、商品模特图生成、商品主图及副图生成、商品详情套图生成、营销素材生成以及其他相关服务。
      </p>
      <p>
        <strong>请您在使用象寄服务前仔细阅读并充分理解本政策，特别是以粗体标示的涉及您重大权益的内容。</strong>
      </p>
      <p>本政策与《象寄用户服务条款》《象寄订阅服务购买协议》以及其他适用的专项服务协议共同构成象寄服务条款体系。</p>
      <p>如果您不同意本政策的任何内容，请停止使用象寄服务。</p>
      <section>
        <h2>一、我们收集哪些信息</h2>
        <p>根据您使用象寄的具体功能以及您与我们的互动方式，我们可能收集以下类型的信息。</p>
        <h3>账号及身份信息</h3>
        <p>当您注册、登录或使用象寄服务时，我们可能收集：</p>
        <ul>
          <li>姓名或昵称；</li>
          <li>电子邮箱；</li>
          <li>手机号码；</li>
          <li>头像；</li>
          <li>第三方账号信息；</li>
          <li>账号ID；</li>
          <li>企业名称、职位等您主动提供的信息；</li>
          <li>其他用于账号注册、身份验证及账号管理的信息。</li>
        </ul>
        <p>
          如果您通过 Google、Apple、微信或其他第三方账号登录，我们可能根据第三方平台授权范围获得您的部分公开账号信息。
        </p>
        <p>
          <strong>我们不会因您使用第三方账号登录而获得您的第三方账号密码。</strong>
        </p>
        <h3>用户上传及提交的内容</h3>
        <p>
          象寄是一款AI视觉内容创作和处理服务，因此在您主动使用相关功能时，我们可能处理您上传、提交或输入的内容，包括但不限于：
        </p>
        <ul>
          <li>商品图片；</li>
          <li>商品详情图；</li>
          <li>商品主图及副图；</li>
          <li>图片中的文字；</li>
          <li>商品名称、描述、规格及参数；</li>
          <li>Prompt及其他文本指令；</li>
          <li>图片编辑指令；</li>
          <li>视频及音频；</li>
          <li>PSD及其他设计文件；</li>
          <li>AI生成结果；</li>
          <li>您主动提交的其他内容。</li>
        </ul>
        <p>
          <strong>
            上述内容可能包含商业秘密、商业素材或其他具有商业价值的信息，请您在上传前确认您有权将相关内容提供给象寄处理。
          </strong>
        </p>
        <h3>交易及支付信息</h3>
        <p>当您购买象寄订阅服务或其他收费服务时，我们可能收集：</p>
        <ul>
          <li>订单信息；</li>
          <li>购买的套餐及服务；</li>
          <li>交易金额；</li>
          <li>交易时间；</li>
          <li>支付状态；</li>
          <li>发票及相关信息；</li>
          <li>与交易相关的账号信息。</li>
        </ul>
        <p>
          <strong>
            对于银行卡号、信用卡号、支付密码等敏感支付信息，我们通常由第三方支付服务商直接处理，象寄原则上不会直接存储完整的银行卡号或支付密码。
          </strong>
        </p>
        <p>具体支付信息的处理方式还应以相应支付服务商的隐私政策为准。</p>
        <h3>设备及日志信息</h3>
        <p>当您访问或使用象寄服务时，我们可能自动收集：</p>
        <ul>
          <li>IP地址；</li>
          <li>浏览器类型及版本；</li>
          <li>操作系统；</li>
          <li>设备类型；</li>
          <li>设备标识符；</li>
          <li>使用语言；</li>
          <li>时区；</li>
          <li>访问时间；</li>
          <li>页面访问记录；</li>
          <li>点击、操作及功能使用记录；</li>
          <li>API调用记录；</li>
          <li>错误日志；</li>
          <li>网络状态；</li>
          <li>其他必要的技术日志信息。</li>
        </ul>
        <p>这些信息主要用于保障服务正常运行、分析故障、提升产品体验及保障平台安全。</p>
        <h3>Cookie及类似技术</h3>
        <p>我们可能使用Cookie、Local Storage、SDK及其他类似技术，用于：</p>
        <ul>
          <li>保持登录状态；</li>
          <li>保存您的偏好设置；</li>
          <li>记住相关操作；</li>
          <li>分析产品使用情况；</li>
          <li>保障账号及服务安全；</li>
          <li>改进产品功能；</li>
          <li>统计服务使用情况。</li>
        </ul>
        <p>
          <strong>您可以通过浏览器或设备设置管理或删除Cookie，但关闭部分Cookie可能导致部分功能无法正常使用。</strong>
        </p>
      </section>
      <section>
        <h2>二、我们如何使用您的个人信息</h2>
        <p>我们会根据合法、正当、必要的目的处理您的个人信息，主要用于以下场景：</p>
        <h3>提供和维护服务</h3>
        <p>包括：</p>
        <ul>
          <li>创建及管理您的账号；</li>
          <li>验证您的身份；</li>
          <li>提供图片翻译服务；</li>
          <li>提供图片编辑及处理服务；</li>
          <li>提供AI图片生成服务；</li>
          <li>提供商品详情套图及主副图生成服务；</li>
          <li>提供视频及其他视觉内容处理服务；</li>
          <li>保存您的作品和历史记录；</li>
          <li>处理您的订单及订阅；</li>
          <li>提供客户支持。</li>
        </ul>
        <h3>AI服务处理</h3>
        <p>当您使用AI相关功能时，我们可能使用您提供的图片、文字、Prompt、商品信息及其他输入内容来：</p>
        <ul>
          <li>理解您的需求；</li>
          <li>调用相应AI模型；</li>
          <li>完成图片翻译、生成、编辑或处理；</li>
          <li>生成AI输出结果；</li>
          <li>保存生成历史；</li>
          <li>向您展示生成结果；</li>
          <li>优化相关服务体验。</li>
        </ul>
        <p>
          <strong>
            为了完成AI相关服务，我们可能需要将实现特定功能所必需的数据传输给相应的AI模型服务商、云服务商或其他技术服务提供商。具体情况请参见本政策“信息共享、委托处理及第三方服务”部分。
          </strong>
        </p>
        <h3>服务改进及产品分析</h3>
        <p>在符合法律法规和本政策约定的前提下，我们可能使用相关信息进行：</p>
        <ul>
          <li>产品分析；</li>
          <li>服务质量分析；</li>
          <li>故障排查；</li>
          <li>性能优化；</li>
          <li>用户体验改进；</li>
          <li>产品功能研发；</li>
          <li>安全风险分析。</li>
        </ul>
        <p>
          <strong>除非取得您的单独授权或法律法规允许，我们不会将您的个人信息用于与原始收集目的无关的用途。</strong>
        </p>
        <h3>客户服务</h3>
        <p>当您联系我们进行咨询、投诉或反馈时，我们可能使用您提供的信息核实您的身份、了解问题并向您提供服务。</p>
        <h3>安全及风险控制</h3>
        <p>我们可能使用相关信息：</p>
        <ul>
          <li>防止账号盗用；</li>
          <li>防止欺诈；</li>
          <li>检测异常登录；</li>
          <li>防止恶意调用；</li>
          <li>防止刷量及套利；</li>
          <li>检测违反平台规则的行为；</li>
          <li>维护平台及用户安全。</li>
        </ul>
        <h3>通知及营销</h3>
        <p>我们可能向您发送与服务有关的重要通知，例如：</p>
        <ul>
          <li>账号安全通知；</li>
          <li>订单及支付通知；</li>
          <li>订阅状态通知；</li>
          <li>服务变更通知；</li>
          <li>隐私政策及服务条款更新通知。</li>
        </ul>
        <p>
          <strong>上述属于提供服务所必要的重要通知，您通常无法拒绝接收。</strong>
        </p>
        <p>
          对于营销信息、活动推广及其他商业性信息，我们将按照适用法律法规及相关授权规则向您发送，并在法律要求的情况下提供相应的拒绝或退订方式。
        </p>
      </section>
      <section>
        <h2>三、AI服务及用户上传内容的特别说明</h2>
        <p>由于象寄提供AI视觉内容创作服务，本部分对相关数据处理进行特别说明。</p>
        <h3>用户上传内容</h3>
        <p>
          当您主动上传图片、文字、视频、PSD或其他内容并要求象寄进行处理时，我们会在提供相关服务所必需的范围内对这些内容进行处理。
        </p>
        <p>例如：</p>
        <p>您上传一张商品图片并选择“图片翻译”，我们可能处理该图片中的视觉内容及文字，以完成翻译并生成新的图片。</p>
        <p>您输入商品信息并选择“商品主图生成”，我们可能处理相关商品信息及您的生成指令，以完成AI生成任务。</p>
        <h3>AI模型服务</h3>
        <p>
          <strong>为了完成部分AI功能，您的输入内容可能需要被传输至象寄使用的第三方AI模型或技术服务商。</strong>
        </p>
        <p>
          我们会根据业务需要选择具有相应安全能力和服务条件的供应商，并按照适用法律法规及合同约定对相关数据进行管理。
        </p>
        <p>具体第三方服务可能随着技术方案和产品功能调整而变化。</p>
        <h3>不用于训练的原则</h3>
        <p>
          <strong>
            除非获得您的明确授权、适用法律法规允许或相关服务页面另有明确说明，象寄不会将您上传的商业素材、商品图片、Prompt或其他用户内容用于训练第三方AI模型。
          </strong>
        </p>
        <p>
          如未来我们计划将相关数据用于模型训练、算法优化或其他与原始服务目的存在实质区别的用途，我们将根据适用法律法规履行相应的告知和授权义务。
        </p>
        <h3>AI生成结果</h3>
        <p>AI生成结果可能包含与原始输入不同的信息或内容。</p>
        <p>我们可能保存您的生成任务及结果，用于向您提供历史记录、下载、再次编辑及其他产品功能。</p>
        <p>
          <strong>您应根据实际商业使用场景对AI生成结果进行人工审核。</strong>
        </p>
      </section>
      <section>
        <h2>四、我们如何共享、委托处理您的信息</h2>
        <p>我们不会出售您的个人信息。</p>
        <p>在以下情况下，我们可能共享或委托第三方处理必要的信息：</p>
        <h3>技术服务供应商</h3>
        <p>为了提供象寄服务，我们可能使用第三方提供的：</p>
        <ul>
          <li>云计算服务；</li>
          <li>对象存储服务；</li>
          <li>AI模型服务；</li>
          <li>机器翻译服务；</li>
          <li>OCR服务；</li>
          <li>图片处理服务；</li>
          <li>数据分析服务；</li>
          <li>客服服务；</li>
          <li>邮件及短信服务；</li>
          <li>支付服务；</li>
          <li>安全服务。</li>
        </ul>
        <p>
          <strong>
            我们仅会向相关服务商提供完成特定服务所必需的信息，并要求其按照适用法律法规及双方约定处理相关信息。
          </strong>
        </p>
        <h3>支付服务商</h3>
        <p>当您购买收费服务时，相关交易可能由第三方支付机构完成。</p>
        <p>支付机构可能根据其隐私政策独立处理支付相关信息。</p>
        <h3>企业客户</h3>
        <p>
          如果您通过企业、学校或其他组织提供的账号使用象寄服务，您的部分账号信息及服务使用信息可能由相应组织进行管理。
        </p>
        <p>如相关组织作为您的个人信息处理者或业务管理方，您应同时向其了解相关数据处理规则。</p>
        <h3>法律及监管要求</h3>
        <p>在以下情况下，我们可能根据法律法规或政府、司法、监管机构的合法要求披露相关信息：</p>
        <ul>
          <li>履行法定义务；</li>
          <li>配合司法调查；</li>
          <li>配合行政调查；</li>
          <li>保护用户或公众安全；</li>
          <li>维护象寄合法权益；</li>
          <li>处理欺诈、违法或安全事件。</li>
        </ul>
        <h3>公司经营变化</h3>
        <p>
          如果象寄发生合并、分立、收购、资产转让、重组或其他类似交易，您的个人信息可能作为相关业务资产的一部分进行转移。
        </p>
        <p>
          <strong>
            如相关交易导致个人信息处理目的或处理方式发生重大变化，我们将按照适用法律法规履行相应的告知义务。
          </strong>
        </p>
      </section>
      <section>
        <h2>五、个人信息的跨境提供</h2>
        <p>象寄面向全球跨境电商用户提供服务，部分服务器、AI模型、云服务或其他技术服务提供商可能位于中国境外。</p>
        <p>
          因此，
          <strong>
            在部分情况下，为向您提供服务，我们可能需要将您的相关个人信息或用户内容传输至其他国家或地区进行处理。
          </strong>
        </p>
        <p>例如：</p>
        <ul>
          <li>您使用境外AI模型完成图片生成；</li>
          <li>您使用境外云服务进行数据存储或处理；</li>
          <li>您使用境外支付服务完成订阅购买；</li>
          <li>您使用境外客服、邮件或数据分析服务。</li>
        </ul>
        <p>
          <strong>
            如相关数据处理涉及个人信息跨境提供，我们将按照适用法律法规履行相应的合规义务，并采取合理的安全保护措施。
          </strong>
        </p>
        <p>对于不同地区的用户，我们可能根据适用法律法规采取不同的数据跨境处理机制。</p>
      </section>
      <section>
        <h2>六、我们如何保护您的个人信息</h2>
        <p>我们重视个人信息安全，并采取合理的技术和管理措施保护您的信息，包括但不限于：</p>
        <ul>
          <li>数据传输加密；</li>
          <li>数据访问权限控制；</li>
          <li>身份认证及权限管理；</li>
          <li>日志记录与安全监控；</li>
          <li>数据备份；</li>
          <li>异常访问检测；</li>
          <li>安全事件响应机制。</li>
        </ul>
        <p>
          <strong>
            我们会根据业务实际情况采取合理措施防止个人信息遭到未经授权的访问、使用、修改、披露、丢失或破坏。
          </strong>
        </p>
        <p>但是，互联网环境并非绝对安全。</p>
        <p>
          如果发生个人信息安全事件，我们将按照适用法律法规采取相应措施，并在法律要求的情况下及时通知相关用户及监管机构。
        </p>
      </section>
      <section>
        <h2>七、个人信息的保存</h2>
        <p>我们仅在实现本政策所述目的所必要的期限内保存您的个人信息。</p>
        <p>保存期限主要根据以下因素确定：</p>
        <ul>
          <li>提供相关服务所需的期限；</li>
          <li>维护账号及历史记录所需的期限；</li>
          <li>法律法规规定的保存期限；</li>
          <li>解决争议及处理投诉所需的期限；</li>
          <li>履行其他法定义务所需的期限。</li>
        </ul>
        <p>
          <strong>当保存期限届满后，我们将按照适用法律法规删除、匿名化或采取其他合法方式处理相关信息。</strong>
        </p>
        <p>
          对于您主动上传的图片、视频、PSD、Prompt及其他用户内容，我们会根据具体产品功能、账号状态及存储规则确定保存期限。
        </p>
      </section>
      <section>
        <h2>八、您对个人信息享有的权利</h2>
        <p>在适用法律法规规定的范围内，您可能享有以下权利：</p>
        <h3>查询和访问</h3>
        <p>您可以查询或访问我们持有的与您有关的个人信息。</p>
        <h3>更正</h3>
        <p>当您发现个人信息存在错误或不准确时，可以要求我们进行更正。</p>
        <h3>删除</h3>
        <p>在符合法律法规规定的情况下，您可以要求我们删除相关个人信息。</p>
        <h3>注销账号</h3>
        <p>您可以按照象寄提供的方式申请注销账号。</p>
        <p>
          <strong>
            账号注销后，部分服务数据及未使用的服务权益可能按照相关规则失效或删除。法律法规要求继续保存的信息除外。
          </strong>
        </p>
        <h3>撤回授权</h3>
        <p>在法律允许的范围内，您可以撤回此前给予我们的部分授权。</p>
        <p>但撤回授权可能影响部分功能或服务的正常使用。</p>
        <h3>限制或拒绝处理</h3>
        <p>在符合法律法规规定的情况下，您可以要求我们限制或停止对您的个人信息进行处理。</p>
        <h3>获取个人信息副本</h3>
        <p>在适用法律法规允许的情况下，您可以请求获取您的个人信息副本。</p>
        <p>如您希望行使上述权利，可以通过本政策“联系我们”部分提供的联系方式向我们提出申请。</p>
        <p>
          <strong>为了保护账号及个人信息安全，我们可能需要验证您的身份。</strong>
        </p>
      </section>
      <section>
        <h2>九、未成年人隐私保护</h2>
        <p>象寄的主要服务对象为成年人及企业用户。</p>
        <p>
          <strong>
            如您未满18周岁，请在父母或其他法定监护人的陪同下阅读本政策，并在获得监护人同意后使用相关服务。
          </strong>
        </p>
        <p>
          如果我们发现未成年人在未经适当监护人同意的情况下向我们提供了个人信息，我们将在法律允许的范围内采取合理措施进行处理。
        </p>
      </section>
      <section>
        <h2>十、第三方服务及链接</h2>
        <p>象寄服务可能包含第三方网站、软件、插件、支付服务、AI模型或其他第三方服务。</p>
        <p>例如，您可能通过第三方账号登录，或者使用第三方支付、AI模型及其他技术服务。</p>
        <p>
          <strong>第三方服务由相应第三方独立提供，其个人信息处理行为受该第三方自身隐私政策约束。</strong>
        </p>
        <p>我们建议您在使用相关第三方服务前阅读其隐私政策。</p>
      </section>
      <section>
        <h2>十一、隐私政策的变更</h2>
        <p>由于法律法规、技术、产品及业务的发展，我们可能对本政策进行更新或修改。</p>
        <p>当本政策发生重大变更时，我们将通过网站公告、产品页面、弹窗、站内通知或其他合理方式向您进行提示。</p>
        <p>
          <strong>更新后的隐私政策自公布或规定的生效日期起生效。</strong>
        </p>
        <p>如您不同意修改后的政策内容，您可以停止使用相关服务。</p>
        <p>如果您继续使用象寄服务，则视为您已阅读并理解更新后的隐私政策。</p>
      </section>
      <section>
        <h2>十二、联系我们</h2>
        <p>如果您对本隐私政策、个人信息处理或其他隐私相关事项有任何问题、意见或投诉，可以通过以下方式联系我们：</p>
        <ul>
          <li>
            官方网站：
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>在线客服：象寄产品内在线客服</li>
          <li>客服邮箱：510807298@qq.com</li>
          <li>公司名称：苏州象寄科技服务有限公司</li>
          <li>
            公司地址：<strong>上海市浦东新区纳贤路800号科海大楼</strong>
          </li>
        </ul>
        <p>我们将在收到您的隐私相关请求后，在适用法律法规规定的期限内进行处理。</p>
      </section>
    </>
  );
};

export default ZhContent;
